module.exports = __webpack_public_path__ + "static/img/cj0.6216546.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cj0.jpeg
// module id = cicC
// module chunks = 0